import { render, staticRenderFns } from "./EmployeeStatus.vue?vue&type=template&id=2d043fe0&"
import script from "./EmployeeStatus.vue?vue&type=script&lang=js&"
export * from "./EmployeeStatus.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports